module.exports = __webpack_public_path__ + "img/selbsterfahrung_1920.aed06705.png";